import React, { useState, useCallback } from 'react'
import { Button } from '@/atoms/Button'
import { CaptionSM, ParagraphMD, ParagraphSM } from '@/atoms/Text'
import { ANGEL_STUDIOS_EMAIL_GROUP_ID } from '@/constants/email'
import { GTitleLG, GTitleXXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { EmailCaptureFormInput } from '@/views/SignUpView/EmailCapture/EmailCaptureFormInput/EmailCaptureFormInput'
import { EmailModal } from '@/views/YoungWashingtonView/components/EmailModal'

export default function EmailSignup() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleSubmit = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <section className=" relative py-10 md:p-16">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#da2031]"></div>
        <div
          className="bg-top-left absolute inset-0 bg-repeat opacity-30 mix-blend-multiply"
          style={{
            backgroundImage:
              "url('https://images.angelstudios.com/image/upload/c_limit,w_1200,q_50/v1759419818/theatrical/young%20washington/dirt-texture-on-white-01.webp')",
            backgroundSize: '1024px 512px',
          }}
        ></div>
      </div>
      <div className="container relative mx-auto max-w-[680px] px-4 text-center text-white">
        <GTitleXXL className="hidden text-balance md:block">Stay Up To Date On Everything Young Washington</GTitleXXL>
        <GTitleLG className="text-balance md:hidden">Stay Up To Date On Everything Young Washington</GTitleLG>
        <ParagraphMD className={'mb-10 mt-1 hidden text-balance !font-roboto !font-light md:block'}>
          Be part of the movement and get the latest news, events, and updates as we march toward Young Washington
        </ParagraphMD>
        <ParagraphSM className={'mb-8 mt-2 text-balance !font-roboto !font-light md:hidden'}>
          Be part of the movement and get the latest news, events, and updates as we march toward Young Washington
        </ParagraphSM>

        <EmailCaptureFormInput
          position="young-washington-email-signup"
          subscriptionGroupId={ANGEL_STUDIOS_EMAIL_GROUP_ID}
          projectSlug="young-washington"
          placeholder="Enter your email..."
          formClassName="mx-auto flex max-w-md gap-1 mb-8 md:mb-10"
          inputClassName="flex-1 rounded px-4 py-3 !font-roboto text-sm rounded-xl mr-4 md:w-[326px] !text-black w-full "
          inputWrapperClassName={'w-full'}
          onSubmit={handleSubmit}
        >
          <Button
            variant={'oxide-primary'}
            outline={false}
            size={'md'}
            className={'mt-4 w-full !border-[#00142E] !bg-[#00142E] !font-roboto md:mt-0 md:w-fit'}
            type="submit"
          >
            Submit
          </Button>
        </EmailCaptureFormInput>
        <CaptionSM className="text-balance !font-roboto !font-light">
          By providing your email address, you agree to receive communications related to this community, including
          updates, announcements, and important notices. We will not sell or share your email with third parties without
          your consent, except as required by law. You may unsubscribe or request removal at any time. Participation is
          subject to our{' '}
          <a href={'https://www.angel.com/legal/terms-of-use'} target={'_blank'} className={'underline'}>
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={'https://www.angel.com/legal/privacy'} target={'_blank'} className={'underline'}>
            Privacy Policy
          </a>
          . Welcome to the Revolution!
        </CaptionSM>
        {/*<p className="mt-4 text-xs text-white"> TODO WE NEED THIS*/}
        {/*  This is where any legal verbiage would go for email submit where Privacy Policy and Terms of Service apply.*/}
        {/*</p>*/}

        <EmailModal handleCloseModal={handleCloseModal} isModalOpen={isModalOpen} />
      </div>
    </section>
  )
}
